export enum LocalStorageKeys {
  UserData = 'userData',
}
